import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({ code: "", type: "percent", value: 10, valid_until: "", max_uses: "", active: true });

  const load = () => api.get("/admin/coupons").then((r) => setCoupons(r.data));

  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        value: Number(form.value),
        max_uses: form.max_uses ? Number(form.max_uses) : null,
        valid_until: form.valid_until || null,
        uses: 0,
      };
      await api.post("/admin/coupons", payload);
      toast.success("Cupom criado");
      setForm({ code: "", type: "percent", value: 10, valid_until: "", max_uses: "", active: true });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro");
    }
  };

  const remove = async (code) => {
    if (!confirm(`Excluir cupom ${code}?`)) return;
    await api.delete(`/admin/coupons/${code}`);
    load();
  };

  return (
    <div data-testid="admin-coupons">
      <p className="overline text-[#A8A8A8] mb-1">Promoções</p>
      <h1 className="font-display text-4xl mb-10">Cupons</h1>

      <div className="bg-white p-8 mb-8">
        <h3 className="font-display text-xl mb-5">Novo cupom</h3>
        <form onSubmit={create} className="grid md:grid-cols-2 gap-4">
          <Field label="Código">
            <input data-testid="coupon-code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} required className="input" placeholder="SUMMER2026" />
          </Field>
          <Field label="Tipo">
            <select data-testid="coupon-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="input">
              <option value="percent">Porcentagem (%)</option>
              <option value="fixed">Valor fixo (R$)</option>
            </select>
          </Field>
          <Field label="Valor">
            <input data-testid="coupon-value" type="number" step="0.01" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} required className="input" />
          </Field>
          <Field label="Validade (opcional)">
            <input type="date" value={form.valid_until} onChange={(e) => setForm({ ...form, valid_until: e.target.value })} className="input" />
          </Field>
          <Field label="Limite de usos (opcional)">
            <input type="number" value={form.max_uses} onChange={(e) => setForm({ ...form, max_uses: e.target.value })} className="input" />
          </Field>
          <div className="md:col-span-2">
            <button type="submit" className="btn-primary" data-testid="create-coupon-btn"><Plus size={14} className="mr-2"/> Criar cupom</button>
          </div>
        </form>
      </div>

      <div className="bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#FAF9F7] text-left">
            <tr>
              <th className="p-4 overline text-[#A8A8A8]">Código</th>
              <th className="p-4 overline text-[#A8A8A8]">Tipo</th>
              <th className="p-4 overline text-[#A8A8A8]">Valor</th>
              <th className="p-4 overline text-[#A8A8A8]">Validade</th>
              <th className="p-4 overline text-[#A8A8A8]">Usos</th>
              <th className="p-4 overline text-[#A8A8A8]">Ações</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((c) => (
              <tr key={c.code} className="border-t border-[#E8E4DF]" data-testid={`coupon-row-${c.code}`}>
                <td className="p-4 font-medium">{c.code}</td>
                <td className="p-4 text-[#6B6B6B]">{c.type === "percent" ? "%" : "R$"}</td>
                <td className="p-4">{c.type === "percent" ? `${c.value}%` : `R$ ${c.value}`}</td>
                <td className="p-4 text-[#6B6B6B]">{c.valid_until || "—"}</td>
                <td className="p-4">{c.uses || 0}{c.max_uses ? ` / ${c.max_uses}` : ""}</td>
                <td className="p-4">
                  <button onClick={() => remove(c.code)} className="text-red-600 hover:text-red-800" data-testid={`del-coupon-${c.code}`}><Trash2 size={14}/></button>
                </td>
              </tr>
            ))}
            {coupons.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-[#A8A8A8]">Nenhum cupom cadastrado.</td></tr>}
          </tbody>
        </table>
      </div>

      <style>{`.input { width: 100%; border: 1px solid #E8E4DF; padding: 10px 14px; background: white; }
        .input:focus { outline: none; border-color: #B8A88A; }`}</style>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="overline text-[#A8A8A8] mb-2 block">{label}</label>
      {children}
    </div>
  );
}
